import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { $getLoadedMaterial, $variantIndices } from '../material.js';
import { $correlatedObjects } from '../three-dom-element.js';
// Defines the base level node methods and data.
export var Node = /*#__PURE__*/_createClass(function Node(name) {
  _classCallCheck(this, Node);
  this.name = '';
  this.children = new Array();
  this.name = name;
});
// Represents a primitive in a glTF mesh.
export var PrimitiveNode = /*#__PURE__*/function (_Node) {
  _inherits(PrimitiveNode, _Node);
  var _super = _createSuper(PrimitiveNode);
  function PrimitiveNode(mesh, mvMaterials, modelVariants, correlatedSceneGraph) {
    var _this;
    _classCallCheck(this, PrimitiveNode);
    _this = _super.call(this, mesh.name);
    // Maps glTF material index number to a material that this primitive supports.
    _this.materials = new Map();
    // Maps variant index to material.
    _this.variantToMaterialMap = new Map();
    _this.initialMaterialIdx = 0;
    _this.activeMaterialIdx = 0;
    _this.mesh = mesh;
    var gltf = correlatedSceneGraph.gltf,
      threeGLTF = correlatedSceneGraph.threeGLTF,
      threeObjectMap = correlatedSceneGraph.threeObjectMap;
    _this.parser = threeGLTF.parser;
    _this.modelVariants = modelVariants;
    _this.mesh.userData.variantData = modelVariants;
    // Captures the primitive's initial material.
    var materialMappings = threeObjectMap.get(mesh.material);
    if (materialMappings.materials != null) {
      _this.initialMaterialIdx = _this.activeMaterialIdx = materialMappings.materials;
    } else {
      console.error("Primitive (".concat(mesh.name, ") missing initial material reference."));
    }
    // Gets the mesh index from the node.
    var associations = mesh.userData.associations || {};
    if (associations.meshes == null) {
      console.error('Mesh is missing primitive index association');
      return _possibleConstructorReturn(_this);
    }
    // The gltf mesh array to sample from.
    var meshElementArray = gltf['meshes'] || [];
    // List of primitives under the mesh.
    var gltfPrimitives = meshElementArray[associations.meshes].primitives || [];
    var gltfPrimitive = gltfPrimitives[associations.primitives];
    if (gltfPrimitive == null) {
      console.error('Mesh primitive definition is missing.');
      return _possibleConstructorReturn(_this);
    }
    // Maps the gltfPrimitive default to a material.
    if (gltfPrimitive.material != null) {
      _this.materials.set(gltfPrimitive.material, mvMaterials[gltfPrimitive.material]);
    } else {
      var defaultIdx = mvMaterials.findIndex(function (mat) {
        return mat.name === 'Default';
      });
      if (defaultIdx >= 0) {
        _this.materials.set(defaultIdx, mvMaterials[defaultIdx]);
      } else {
        console.warn('gltfPrimitive has no material!');
      }
    }
    if (gltfPrimitive.extensions && gltfPrimitive.extensions['KHR_materials_variants']) {
      var variantsExtension = gltfPrimitive.extensions['KHR_materials_variants'];
      var extensions = threeGLTF.parser.json.extensions;
      var variantNames = extensions['KHR_materials_variants'].variants;
      // Provides definition now that we know there are variants to
      // support.
      var _iterator = _createForOfIteratorHelper(variantsExtension.mappings),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mapping = _step.value;
          var mvMaterial = mvMaterials[mapping.material];
          // Maps variant indices to Materials.
          _this.materials.set(mapping.material, mvMaterial);
          var _iterator2 = _createForOfIteratorHelper(mapping.variants),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var variant = _step2.value;
              var name = variantNames[variant].name;
              _this.variantToMaterialMap.set(variant, mvMaterial);
              // Provides variant info for material self lookup.
              mvMaterial[$variantIndices]().add(variant);
              // Updates the models variant data.
              if (!modelVariants.has(name)) {
                modelVariants.set(name, {
                  name: name,
                  index: variant
                });
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return _this;
  }
  _createClass(PrimitiveNode, [{
    key: "setActiveMaterial",
    value: function () {
      var _setActiveMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(material) {
        var mvMaterial, normalScale;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              mvMaterial = this.materials.get(material);
              if (!(mvMaterial != null && material !== this.activeMaterialIdx)) {
                _context.next = 8;
                break;
              }
              _context.next = 4;
              return mvMaterial[$getLoadedMaterial]();
            case 4:
              this.mesh.material = _context.sent;
              normalScale = this.mesh.material.normalScale; // TODO: remove this hack in favor of properly storing the different
              // three.js materials that are potentially created for different meshes
              // that share a glTF material.
              if (normalScale != null && normalScale.y * normalScale.x < 0 != (this.mesh.geometry.attributes.tangent == null)) {
                this.parser.assignFinalMaterial(this.mesh);
              }
              this.activeMaterialIdx = material;
            case 8:
              return _context.abrupt("return", this.mesh.material);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setActiveMaterial(_x) {
        return _setActiveMaterial.apply(this, arguments);
      }
      return setActiveMaterial;
    }()
  }, {
    key: "getActiveMaterial",
    value: function getActiveMaterial() {
      return this.materials.get(this.activeMaterialIdx);
    }
  }, {
    key: "getMaterial",
    value: function getMaterial(index) {
      return this.materials.get(index);
    }
  }, {
    key: "enableVariant",
    value: function () {
      var _enableVariant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name) {
        var modelVariants;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(name == null)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", this.setActiveMaterial(this.initialMaterialIdx));
            case 2:
              if (!(this.variantToMaterialMap != null && this.modelVariants.has(name))) {
                _context2.next = 5;
                break;
              }
              modelVariants = this.modelVariants.get(name);
              return _context2.abrupt("return", this.enableVariantHelper(modelVariants.index));
            case 5:
              return _context2.abrupt("return", null);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function enableVariant(_x2) {
        return _enableVariant.apply(this, arguments);
      }
      return enableVariant;
    }()
  }, {
    key: "enableVariantHelper",
    value: function () {
      var _enableVariantHelper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(index) {
        var material;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.variantToMaterialMap != null && index != null)) {
                _context3.next = 4;
                break;
              }
              material = this.variantToMaterialMap.get(index);
              if (!(material != null)) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return", this.setActiveMaterial(material.index));
            case 4:
              return _context3.abrupt("return", null);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function enableVariantHelper(_x3) {
        return _enableVariantHelper.apply(this, arguments);
      }
      return enableVariantHelper;
    }()
  }, {
    key: "instantiateVariants",
    value: function () {
      var _instantiateVariants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iterator3, _step3, index, variantMaterial, threeMaterial;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.variantToMaterialMap == null)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              _iterator3 = _createForOfIteratorHelper(this.variantToMaterialMap.keys());
              _context4.prev = 3;
              _iterator3.s();
            case 5:
              if ((_step3 = _iterator3.n()).done) {
                _context4.next = 16;
                break;
              }
              index = _step3.value;
              variantMaterial = this.mesh.userData.variantMaterials.get(index);
              if (!(variantMaterial.material != null)) {
                _context4.next = 10;
                break;
              }
              return _context4.abrupt("continue", 14);
            case 10:
              _context4.next = 12;
              return this.enableVariantHelper(index);
            case 12:
              threeMaterial = _context4.sent;
              if (threeMaterial != null) {
                variantMaterial.material = threeMaterial;
              }
            case 14:
              _context4.next = 5;
              break;
            case 16:
              _context4.next = 21;
              break;
            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](3);
              _iterator3.e(_context4.t0);
            case 21:
              _context4.prev = 21;
              _iterator3.f();
              return _context4.finish(21);
            case 24:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 18, 21, 24]]);
      }));
      function instantiateVariants() {
        return _instantiateVariants.apply(this, arguments);
      }
      return instantiateVariants;
    }()
  }, {
    key: "variantInfo",
    get: function get() {
      return this.variantToMaterialMap;
    }
  }, {
    key: "addVariant",
    value: function addVariant(materialVariant, variantName) {
      if (!this.ensureVariantIsUnused(variantName)) {
        return false;
      }
      // Adds the variant to the model variants if needed.
      if (!this.modelVariants.has(variantName)) {
        this.modelVariants.set(variantName, {
          name: variantName,
          index: this.modelVariants.size
        });
      }
      var modelVariantData = this.modelVariants.get(variantName);
      var variantIndex = modelVariantData.index;
      // Updates materials mapped to the variant.
      materialVariant[$variantIndices]().add(variantIndex);
      // Updates internal mappings.
      this.variantToMaterialMap.set(variantIndex, materialVariant);
      this.materials.set(materialVariant.index, materialVariant);
      this.updateVariantUserData(variantIndex, materialVariant);
      return true;
    }
  }, {
    key: "deleteVariant",
    value: function deleteVariant(variantIndex) {
      if (this.variantInfo.has(variantIndex)) {
        this.variantInfo.delete(variantIndex);
        var userDataMap = this.mesh.userData.variantMaterials;
        if (userDataMap != null) {
          userDataMap.delete(variantIndex);
        }
      }
    }
  }, {
    key: "updateVariantUserData",
    value: function updateVariantUserData(variantIndex, materialVariant) {
      // Adds variants name to material variants set.
      materialVariant[$variantIndices]().add(variantIndex);
      this.mesh.userData.variantData = this.modelVariants;
      // Updates import data (see VariantMaterialLoaderPlugin.ts).
      this.mesh.userData.variantMaterials = this.mesh.userData.variantMaterials || new Map();
      var map = this.mesh.userData.variantMaterials;
      map.set(variantIndex, {
        material: materialVariant[$correlatedObjects].values().next().value,
        gltfMaterialIndex: materialVariant.index
      });
    }
  }, {
    key: "ensureVariantIsUnused",
    value: function ensureVariantIsUnused(variantName) {
      var modelVariants = this.modelVariants.get(variantName);
      if (modelVariants != null && this.variantInfo.has(modelVariants.index)) {
        console.warn("Primitive cannot add variant '".concat(variantName, "' for this material, it already exists."));
        return false;
      }
      return true;
    }
  }]);
  return PrimitiveNode;
}(Node);